module.exports = "./img/7402828ab65d69fa770854d415573f52.png";